import { Stack } from '@mui/material'

import { useMutatePersonalSettings } from '@/services'
import { PersonCustomizationDialog } from '@/components/person-customization-dialog.tsx'
import { RowProps } from '@/components/dnd-area/draggable-row.tsx'
import { CreateQrButton } from '@/pages/qrs/components/create-qr-button'

import { KEY_PAGE, defaultSettings, PartialB2BQr } from '../default-settings-b2b-page.tsx'
import { useAppSelector } from '@/stores/hooks.ts'
import { userSelectors } from '@/stores/slices/user-slice.ts'

const defaultSettingsKey = Object.keys(defaultSettings)

export const B2BQrsActions = () => {
  const settings = useAppSelector((state) => userSelectors.personalSettings(state, KEY_PAGE))

  const getSettings = (format: string, personalSettings?: Record<string, string[]>) => {
    const settingsByRequest = personalSettings?.[format] ?? defaultSettingsKey
    const settings: RowProps[] = settingsByRequest
      .filter((e) => defaultSettingsKey.includes(e))
      .map((e) => ({
        id: e,
        label: defaultSettings[e as keyof PartialB2BQr],
        isChecked: true,
      }))
    Object.keys(defaultSettings).forEach((key) => {
      if (!settingsByRequest.includes(key)) {
        settings.push({ id: key, label: defaultSettings[key as keyof PartialB2BQr], isChecked: false })
      }
    })

    return settings
  }

  return (
    <Stack
      direction={{ sm: 'column', px526: 'row' }}
      gap={2}
      justifyContent={{ sm: 'flex-start', px526: 'flex-end' }}
      alignItems="flex-start"
    >
      <CreateQrButton type="B2B" title="Создать B2B ссылку" />
      <PersonCustomizationDialog
        personalSettingsKey={KEY_PAGE}
        mutation={useMutatePersonalSettings()}
        itemsDesktop={getSettings('desktop', settings)}
        itemsMobile={getSettings('mobile', settings)}
      />
    </Stack>
  )
}
